import React, {Component} from 'react';
import {
	Button,
	Col,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Nav,
	NavItem,
	NavLink,
	Row,
	TabContent,
	TabPane
} from "reactstrap";
import Alert from 'react-s-alert';
import Swal from "sweetalert2";
import CustomerGeneralInfo from "./components/CustomerGeneralInfo";
import classnames from "classnames";
import CustomerCommercialInfo from "./components/CustomerCommercialInfo";
import CustomerBankInfo from "./components/CustomerBankInfo";
import CustomerBranchInfo from "./components/CustomerBranchInfo";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import CustomerContractInfo from "./components/CustomerContractInfo";
import CustomerUserInfo from "./components/CustomerUserInfo";
import MailProperty from "./components/MailProperty";
import NavBarKS from "../../components/NavBarKS";
import _ from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import {CustomerBankType, EntegratorIdentifiers} from "../../helper/enums";
import {EntegratorConf} from "../../constants";
import SmsProperty from "./components/SmsProperty";
import moment from "moment";
import {showChemistInformationModal} from "../../helper/permission";
import TurmobModal from "./components/TurmobModal";

class CreateEditCustomer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: {},
			activeTab: '1',
			key: Math.random(),
			childValidInfo: false,
			currentTitle: null,
			addressTabModal: false,
			bankTabModal: false,
			isAlertVisible: false,
			branchConfirmModal: false,
			recentAliasList: [],
			isForbidden: false,
			mode: 'create',
			customerBank: {
				recordId: '',
				bankName: '',
				iban: '',
				type: showChemistInformationModal() ? CustomerBankType.SGK : CustomerBankType.OTHER
			},
			customerBranchAddress: {
				recordId: '',
				branchName: '',
				gbAlias: '',
				postboxAlias: '',
				country: 'Türkiye',
				city: '',
				citySubdivisionName: '',
				webSite: '',
				email: '',
				phone: '',
				fax: '',
				street: '',
				buildingName: '',
				buildingNo: '',
				doorNo: '',
				postalCode: ''
			},
			customerBankList: [],
			customerBranchList: [],
			customerContractList: [],
			customerSubServiceList: [],
			userList: [],
			naceCodeList: [],
			overlayDivStyle: {display: 'none'},
			spinnerStyle: {display: 'none'},
			initState: null,
			sgkMukellefAdi: "",
			sgkMukellefKodu: "",
			fieldsDisabled: false,
			distributorContractList: null

		};

		this.onChangeCustomer = this.onChangeCustomer.bind(this);
		this.onCustomerTypeChange = this.onCustomerTypeChange.bind(this);
		this.onInvoiceDirectionChange = this.onInvoiceDirectionChange.bind(this);
		this.onCustomerStatusChange = this.onCustomerStatusChange.bind(this);
		this.onChangeCustomerBranchAddress = this.onChangeCustomerBranchAddress.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onAliasChange = this.onAliasChange.bind(this);
		this.onCitySubdivisionChange = this.onCitySubdivisionChange.bind(this);
		this.onChangeCustomerBank = this.onChangeCustomerBank.bind(this);
		this.getSubdivisionsByCityForCustomer = this.getSubdivisionsByCityForCustomer.bind(this);
		this.getSubdivisionsByCityForBranch = this.getSubdivisionsByCityForBranch.bind(this);
		this.toggle = this.toggle.bind(this);
		this.fetchValidDataFromChild = this.fetchValidDataFromChild.bind(this);
		this.addBankToCustomer = this.addBankToCustomer.bind(this);
		this.clearCustomerBranchAddress = this.clearCustomerBranchAddress.bind(this);
		this.clearCustomerBank = this.clearCustomerBank.bind(this);
		this.fillBankForm = this.fillBankForm.bind(this);
		this.deleteBankFromCustomer = this.deleteBankFromCustomer.bind(this);
		this.addBranchToCustomer = this.addBranchToCustomer.bind(this);
		this.checkBeforeSubmit = this.checkBeforeSubmit.bind(this);
		this.setContractToCustomer = this.setContractToCustomer.bind(this);
		this.addContractToCustomer = this.addContractToCustomer.bind(this);
		this.passRecentAliasList = this.passRecentAliasList.bind(this);
		this.updateCustomerUserList = this.updateCustomerUserList.bind(this);
		this.updateCustomer = this.updateCustomer.bind(this);
		this.removeAlias = this.removeAlias.bind(this);
		this.fillAddressForm = this.fillAddressForm.bind(this);
		this.onTaxOfficeChange = this.onTaxOfficeChange.bind(this);
		this.onChangeCustomerCity = this.onChangeCustomerCity.bind(this);
		this.onChangeNaceCodes = this.onChangeNaceCodes.bind(this);
		this.arrangeErrorMessage = this.arrangeErrorMessage.bind(this);
		this.defineReadableFieldName = this.defineReadableFieldName.bind(this);
		this.onChangeInvalidatedContractPrice = this.onChangeInvalidatedContractPrice.bind(this);
		this.onChangeInvalidatedContractExplanation = this.onChangeInvalidatedContractExplanation.bind(this);
		this.onCommercialSoftwareChange = this.onCommercialSoftwareChange.bind(this);
		this.addNewCustomerReference = this.addNewCustomerReference.bind(this);
		this.deleteCustomerReference = this.deleteCustomerReference.bind(this);
		this.clearCustomerReferences = this.clearCustomerReferences.bind(this);
		this.setReferencesToInitialState = this.setReferencesToInitialState.bind(this);
		this.manipulateContractList = this.manipulateContractList.bind(this);
		this.setNewContractList = this.setNewContractList.bind(this);
		this.onDistributorChange = this.onDistributorChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.getCurrentAliases = this.getCurrentAliases.bind(this);
		this.combineArray = this.combineArray.bind(this);
		this.reFetchCustomer = this.reFetchCustomer.bind(this);
		this.onInvoiceWorkTypeChange = this.onInvoiceWorkTypeChange.bind(this);
	}

	componentDidMount() {
		let self = this;
		let params = {
			url: `/customer/edit/${this.props.match.params.recordId}`,
			method: 'post'
		};
		request(params)
			.then(response => {
				if (response.data.customer.recordId === null) {
					let customer = response.data.customer;
					customer.earchiveMailSend = true;
					this.setState({
						customer,
						cities: response.data.cities,
						services: response.data.services,
						taxOffices: response.data.taxOffices,
						currencyCodes: response.data.currencyCodes,
						naceCodes: response.data.naceCodes,
						commercialSoftwares: response.data.commercialSoftwares,
						partners: response.data.partners,
						mode: 'create',
						bankList: response.data.bankList
					});
					// console.log('response: %o', response)
				} else {
					let customerBankList = null;
					let customerBranchList = null;
					let customerContractList = null;
					let distributorContractList = null;
					let userList = null;
					let naceCodeList = [];

					if (this.props.isDistributor && (response.data.customer.recordId === this.props.currentUser.customerId)) {
						this.setState({fieldsDisabled: true});
					}

					if (response.data.customer.customerBankList !== null) {
						customerBankList = response.data.customer.customerBankList;
					} else {
						customerBankList = []
					}

					if (response.data.customer.customerBranchList !== null) {
						customerBranchList = response.data.customer.customerBranchList;
					} else {
						customerBranchList = []
					}


					if (response.data.distributorContractList !== null) {
						distributorContractList = response.data.distributorContractList;
					} else {
						distributorContractList = []
					}

					if (response.data.customer.customerContractList !== null) {
						customerContractList = response.data.customer.customerContractList;
					} else {
						customerContractList = []
					}

					if (response.data.customer.userList !== null) {
						userList = response.data.customer.userList;
					} else {
						userList = []
					}

					if (response.data.customer.naceCodeList !== null) {
						let respNcl = response.data.customer.naceCodeList;
						let customer = response.data.customer
						let ncl = [];
						respNcl.map(nc => {
							let naceCode = {};
							let tempNaceCode = {};

							tempNaceCode.id = nc.id;
							tempNaceCode.code = nc.code;
							tempNaceCode.description = nc.description;
							ncl.push(tempNaceCode);

							naceCode.value = nc.id;
							naceCode.label = nc.code + ' , ' + nc.description;
							naceCode.customValue = nc.code;

							naceCodeList.push(naceCode);
						});
						customer.naceCodeList = ncl;

					} else {
						naceCodeList = []
					}

					let initState = deepCopyObject(response.data.customer)

					this.setState({
						initState,
						customer: response.data.customer,
						cities: response.data.cities,
						services: response.data.services,
						taxOffices: response.data.taxOffices,
						naceCodes: response.data.naceCodes,
						commercialSoftwares: response.data.commercialSoftwares,
						partners: response.data.partners,
						customerBankList,
						customerBranchList,
						customerContractList,
						naceCodeList,
						userList,
						mode: 'edit',
						currencyCodes: response.data.currencyCodes,
						distributorContractList,
						bankList: response.data.bankList
					})
				}
			})
			.catch(function (error) {
				if (error.response) {
					if (error.response.status === 403) {
						self.setState({isForbidden: true})
					}
				}
			});
	}

	reFetchCustomer(){
		let self = this;
		if(!this.state.customer.recordId){
			return Promise.reject("Customer record ID is null or undefined.");
		}
		let params = {
			url: `/customer/edit/${this.state.customer.recordId}`,
			method: 'post'
		};
		return request(params)
			.then(response => {
					let customer = response.data.customer;
					let  customerContractList =[];
					let customerBranchList = customer.customerBranchList;

					if (response.data.customer.customerContractList !== null) {
						customerContractList = response.data.customer.customerContractList;
					}

					self.setState({
						customer, customerContractList,customerBranchList
					});

				}).catch(function (error) {
			if (error.response) {
				if (error.response.status === 403) {
					self.setState({isForbidden: true})
				}
			}
		});
	}

	setContractToCustomer(data) {
		let clone = deepCopyObject(data);
		let ccsl = clone.customerContractServiceList;
		ccsl.forEach(ccs => {
			if (ccs.aliasList) {
				ccs.aliasList.forEach(a => {
					delete a.service;
				});
			}
		});

		let customerContractList = this.state.customer.customerContractList;
		if (!customerContractList) {
			customerContractList = [];
		}

		if (customerContractList.length === 0) {
			customerContractList.push(clone);
		} else {
			customerContractList.splice(0, 1, clone);
		}

		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		});
	}

	passRecentAliasList(aliasList) {
		this.setState({
			recentAliasList: aliasList
		})
	}

	addContractToCustomer(data) {
		let clone = deepCopyObject(data);
		let ccsl = clone.customerContractServiceList;
		ccsl.map(ccs => {
			ccs.aliasList && ccs.aliasList.map(a => {
				delete a.service
			});
		});

		let customerContractList = this.state.customer.customerContractList;
		customerContractList.push(clone);
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	onChangeCustomer(e) {
		if(e.target.name === "corporateMail" || e.target.name === "kepAdresi" || e.target.name === "sorumluEPosta" ) e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		let customer = deepCopyObject(this.state.customer);
		let target = e.target;
		const value = target.type === 'checkbox' ? (target.checked) : target.value;

		customer[target.name] = value;
		if (target.name === "formattedName") {
			this.setState({
				customer,
				currentTitle: value
			})
		}
		if (target.name === "distributor" && value === false) {
			customer.allowPrivateAccess = false;
			customer.allowCreditChange = false;
			customer.workType = null;
		}

		if (target.name === "earchiveMailSend") {
			customer.earchiveMailSendChangeDate = moment();
		}

		this.setState({
			customer
		})
	}

	onInvoiceWorkTypeChange(e) {
		if (e.label==="Müşteri Kendi Öder"){
			let customer = deepCopyObject(this.state.customer);
			customer.allowCreditChange = false;
			customer.workType = e.value
			this.setState({customer})
		} else {
			this.setState({
				customer: {
					...this.state.customer,
					workType: e.value
				}
			})
		}
	}

	onInvoiceDirectionChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				invoiceDirection: e.value
			}
		})
	}

	onCustomerTypeChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				customerType: e.value
			}
		})
	}

	onDistributorChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				parentCustomerId: e.value
			}
		})
	}

	onCustomerStatusChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				active: e.value
			}
		})
	}

	onTaxOfficeChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				taxOffice: e.value
			}
		})
	}

	onCommercialSoftwareChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				commercialSoftware: e.label
			}
		})
	}

	onChangeCustomerCity(data) {
		this.setState({
			customer: {
				...this.state.customer,
				city: data
			}
		})
	}

	// ADDRESS OPERATIONS - START
	onCityChange(e) {
		this.setState({
			customerBranchAddress: {
				...this.state.customerBranchAddress,
				city: e.value
			}
		})
	}

	onCitySubdivisionChange(e) {
		this.setState({
			customerBranchAddress: {
				...this.state.customerBranchAddress,
				citySubdivisionName: e.value
			}
		})
	}

	onAliasChange(e) {
		this.setState({
			customerBranchAddress: {
				...this.state.customerBranchAddress,
				[e.name]: e.value
			}
		})
	}

	fillAddressForm(data, index) {
		this.setState({
			newlyAddedBranchIndex: index,
			newlyAddedBranchEditing: data.recordId === "",
			customerBranchAddress: data
		});
	}

	getSubdivisionsByCityForCustomer(data) {
		if (data === null) {
			return [];
		}

		if (this.state.customerAddress.city !== '') {
			return this.state.cities.find(obj => obj.cityName === data).subdivisions.map(subdiv => ({
				value: subdiv.name,
				label: subdiv.name
			}))
		}
	}

	getSubdivisionsByCityForBranch(data) {
		if (data === null) {
			return [];
		}

		if (this.state.customerBranchAddress.city !== '') {
			return this.state.cities.find(obj => obj.cityName === (data.substr(0,1).toLocaleUpperCase("tr-TR") + data.substr(1,data.length).toLocaleLowerCase("tr-TR"))).subdivisions.map(subdiv => ({
				value: subdiv.name,
				label: subdiv.name
			}))
		}
	}

	onChangeCustomerBranchAddress(e) {
		let customerBranchAddress = deepCopyObject(this.state.customerBranchAddress);
		if (e.target.name === "email") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		if (e.target && e.target.name && e.target.value && e.target.name === "postalCode" && isNaN(e.target.value)) {

		} else if (e.target.name === 'hasMesulMudur') {
			if(e.target.checked){
				customerBranchAddress["mesulMudurAdSoyad"] = null;
				customerBranchAddress["mesulMudurBelgeNo"] = null;
				customerBranchAddress["mesulMudurRuhsatnameTarih"] = null;
			}
			customerBranchAddress[e.target.name] = !e.target.checked;
		} else {
			customerBranchAddress[e.target.name] = e.target.value === "" ? null : e.target.value;
		}
		this.setState({
			customerBranchAddress
		})
	}

	clearCustomerBranchAddress() {
		let customerBranchAddress = {
			recordId: '',
			branchName: '',
			gbAlias: '',
			postboxAlias: '',
			country: 'Türkiye',
			city: '',
			citySubdivisionName: '',
			webSite: '',
			email: '',
			phone: '',
			fax: '',
			street: '',
			buildingName: '',
			buildingNo: '',
			doorNo: '',
			postalCode: ''
		};
		this.setState({
			customerBranchAddress
		})
	}

	// ADDRESS OPERATIONS - END

	// BANK OPERATIONS - START
	onChangeCustomerBank(e, name) {
		if(e&&e.target){
			this.setState({
				customerBank: {
					...this.state.customerBank,
					[e.target.name]: e.target.name === "iban" ? e.target.value.replace(/\s/g, '') : e.target.value
				}
			})
		}else{
			this.setState({
				customerBank: {
					...this.state.customerBank,
					[name]:e.value
				}
			})
		}
	}

	clearCustomerBank() {
		let customerBank = {
			recordId: '',
			bankName: '',
			iban: '',
			type: showChemistInformationModal() ? CustomerBankType.SGK : CustomerBankType.OTHER
		};
		this.setState({
			customerBank
		})
	}

	addBankToCustomer() {
		let result = this.bankInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let customerBankList = deepCopyObject(this.state.customerBankList);
				customerBankList.push(this.state.customerBank);
				this.setState({
					customerBankList,
					customer: {
						...this.state.customer,
						customerBankList
					}
				}, () => this.clearCustomerBank());
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}
		})
	}

	deleteBankFromCustomer(data) {
		let self = this;
		let params = {
			url: `/customer/deleteBank/${data}`,
			method: 'post'
		};
		self.setState({deleteBtnDisabled: true});
		request(params)
			.then(function (response) {
				Swal({
					title: 'Başarılı ! ',
					text: ("Silme işlemi başarıyla gerçekleştirildi."),
					type: 'success',
					confirmButtonText: 'Tamam'
				})
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	fillBankForm(data) {
		this.setState({
			customerBank: data,
		})
	}

	// BANK OPERATIONS - END

	toggle(tab) {

		this.setState({
			activeTab: tab
		})
	}

	fetchValidDataFromChild(data) {
		this.setState({
			childValidInfo: data.valid
		})
	}

	checkBeforeSubmit(info) {
		let init = deepCopyObject(this.state.initState);
		let final = deepCopyObject(this.state.customer);
		
		if (!this.state.customer.customerContractList ||
			this.state.customer.customerContractList.some(contract => contract.rateType === null || contract.rateType === '')) {
			Alert.error("Lütfen sözleşme türünü seçin.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			return;
		}

		if (!(_.isEqual(init, final))) {
			let error = {};

			let generalValidity = this.generalInfoChild.validateComponent();
			let generalInfoError = this.generalInfoChild.state.error;
			for (let key in generalInfoError) {
				error[key] = generalInfoError[key];
			}

			let commercialValidity = this.commercialInfoChild.validateComponent();
			let commercialInfoError = this.commercialInfoChild.state.error;
			for (let key in commercialInfoError) {
				error[key] = commercialInfoError[key];
			}

			let contractValidity = {};

			if (!this.state.customer.customerContractList) {
				contractValidity.valid = true;
			} else {
				contractValidity = this.contractInfoChild.validateComponent();
			}

			let contractInfoError = this.contractInfoChild.state.error;
			for (let key in contractInfoError) {
				error[key] = contractInfoError[key];
			}

			this.setState({
				error
			}, function () {
				if (generalValidity.valid && commercialValidity.valid && contractValidity.valid) {
					if (this.state.customer.customerBranchList === null) {
						this.setState({
							branchConfirmModal: true
						});
					} else {
						this.setState(prevState => ({
							customer: {
								...prevState.customer,
								customerContractServiceList: []
							}
						}), () => {
							this.handleSubmit(info);
						});
					}
				} else {
					Alert.error(this.arrangeErrorMessage(), {
						html: true,
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				}
			});
		} else {
			Alert.warning('Herhangi bir değişiklik yapmadınız!', {
				html: true,
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}


	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.error);

		let errorArray = [];

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message && key !== 'tCity') {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}

		this.setState({error: errorObject});

		return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/>').join('')
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tVknTckn':
				return 'Vkn/Tckn: ';
			case 'tCustomerName':
				return 'Müşteri Adı: ';
			case 'tFormattedName':
				return 'Unvan: ';
			case 'tCustomerType':
				return 'Müşteri Tipi: ';
			case 'tGivenName':
				return 'Adı: ';
			case 'tFamilyName':
				return 'Soyadı: ';
			case 'tCorporateMail':
				return 'Kurumsal e-Posta: ';
			case 'tTaxOffice':
				return 'Vergi Dairesi: ';
			case 'tContractStartDate':
				return 'Kontrat Başlangıç Tarihi: ';
			case 'tContractFinishDate':
				return 'Kontrat Bitiş Tarihi: ';
			case 'tRepresentative':
				return 'Müşteri Temsilcisi: ';
			case 'tRegistrantName':
				return 'Kaydeden Adı: ';
			case 'tRegistrantSurname':
				return 'Kaydeden Soyadı: ';
			case 'tRegistrantMobile':
				return 'Kaydeden Cep No: ';
			case 'tSorumluTckn':
				return 'Sorumlu Tckn: ';
			case 'tSorumluAd':
				return 'Sorumlu Adı: ';
			case 'tSorumluSoyad':
				return 'Sorumlu Soyadı: ';
			case 'tSorumluCepTel':
				return 'Sorumlu Cep No: ';
			case 'tSorumluEPosta':
				return 'Sorumlu e-Posta: ';
			case 'tInvoiceDirection':
				return 'Faturalandırma Yöntemi: ';
			case 'workingType':
				return 'Çalışma Şekli';
			default :
				return '';
		}
	}

	switchBranchDetailModal() {
		this.branchInfoChild.remoteSwitchBranchDetailModal();
	}

	handleSubmit(info) {
		this.overlayPage();
		let self = this;
		const data = this.state.customer;
		let currentUser = self.props.currentUser
		if(currentUser.isDistributor){
			data.workType = currentUser.workType;
		}
		let params = {
			url: `/customer/createCustomer`,
			data: data ,
			method: 'post'
		};
		request(params).then(function (response) {
			if (info === null) {
				self.props.history.push(`/customer`);
			} else {
				let customer = response.data;
				let  customerContractList =[];
				if (response.data.customerContractList !== null) {
					customerContractList = response.data.customerContractList;
				}
				self.setState({customer, customerContractList, mode:'edit'}, () => {
					self.reFetchCustomer().then(() => {
						self.props.history.push(`/createEditCustomer/${info ? info : response.data.recordId}`);
					}).catch(error => {
						console.error("Error during re-fetching customer:", error);
					});
				});
			}
			Alert.success("Kayıt işlemi başarıyla gerçekleştirildi.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 1500
			});
		}).then(() => self.setState({overlayDivStyle: {display: 'none'}, spinnerStyle: {display: 'none'}}))
			.catch(function (error) {
				self.setState({overlayDivStyle: {display: 'none'}, spinnerStyle: {display: 'none'}})
				showAxiosError(error);
			});
	}

	defineTabName() {
		if (this.state.activeTab === '1') {
			return 'Sözleşme Bilgileri'
		} else if (this.state.activeTab === '2') {
			return 'Şube Bilgileri'
		} else if (this.state.activeTab === '3') {
			return 'Banka Bilgileri'
		}else if (this.state.activeTab === '6') {
			return 'SMS Bilgileri'
		}else if (this.state.activeTab === '7') {
			return 'TÜRMOB Token Bilgisi'
		} else {
			return 'Kayıtlı Kullanıcılar'
		}
	}

	addBranchToCustomer() {
		let result = this.branchInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let customerBranchAddress = deepCopyObject(this.state.customerBranchAddress);
				let customerBranchList = deepCopyObject(this.state.customerBranchList);

				if (customerBranchAddress.recordId) {
					let found = false;
					let index = null;

					customerBranchList.map(branch => {
						if (branch.recordId === customerBranchAddress.recordId) {
							found = true;
							index = customerBranchList.indexOf(branch);
						}
					});

					if (found === true) {
						customerBranchList.splice(index, 1, customerBranchAddress)
					}

				} else {
					if (this.state.newlyAddedBranchEditing) {
						let index = this.state.newlyAddedBranchIndex;
						customerBranchList.splice(index, 1, customerBranchAddress);
						this.setState({newlyAddedBranchEditing: false})
					} else {
						customerBranchList.push(customerBranchAddress);
					}
				}


				this.setState({

					customerBranchList,
					customer: {
						...this.state.customer,
						customerBranchList
					}
				}, () => this.clearCustomerBranchAddress());
				this.branchInfoChild.remoteSwitchBranchDetailModal();
			} else {
				this.branchInfoChild.showErrorMessage();
			}
		})
	}

	removeAlias(data) {
		let aliasList = [];
		let customerContractList = deepCopyObject(this.state.customer.customerContractList)
		customerContractList.map(cc => {
			cc.customerContractServiceList.map(ccs => {
				if (ccs.service.recordId === 2) {
					aliasList = ccs.aliasList;
					if (data) {
						data.map(a => {
							aliasList.map(alias => {
								if (a.workScopecode === alias.workScopecode) {
									let index = aliasList.indexOf(alias);
									aliasList.splice(index, 1);
								}
							})
						})
					}
					ccs.aliasList = aliasList;
				}
			})
		});
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	updateCustomerUserList(userList) {
		this.setState({
			userList,
			customer: {
				...this.state.customer,
				userList
			}
		})
	}

	updateCustomer(data) {
		this.setState({
			customer: data
		})
	}

	onChangeNaceCodes(data) {
		let customer = deepCopyObject(this.state.customer);
		let customerNcList = [];
		data.map(d => customerNcList.push({id: d.value}));
		customer.naceCodeList = customerNcList;
		this.setState({customer, naceCodeList: data})
	}

	onChangeInvalidatedContractPrice(e, data) {
		let customer = deepCopyObject(this.state.customer);
		let customerContractList = customer.customerContractList;

		let ccIndex = null;
		let ccsIndex = null;
		customerContractList.map(cc => {
			cc.customerContractServiceList.map(ccs => {
				if (data.id === ccs.id) {
					ccIndex = customerContractList.indexOf(cc);
					ccsIndex = cc.customerContractServiceList.indexOf(ccs);
				}
			})
		});

		customerContractList[ccIndex].customerContractServiceList[ccsIndex].price = e.target.value;

		this.setState({customer});
	}

	onChangeInvalidatedContractExplanation(e, data) {
		let customer = deepCopyObject(this.state.customer);
		let customerContractList = customer.customerContractList;

		let ccIndex = null;
		let ccsIndex = null;
		customerContractList.map(cc => {
			cc.customerContractServiceList.map(ccs => {
				if (data.id === ccs.id) {
					ccIndex = customerContractList.indexOf(cc);
					ccsIndex = cc.customerContractServiceList.indexOf(ccs);
				}
			})
		});

		customerContractList[ccIndex].customerContractServiceList[ccsIndex].explanation = e.target.value;

		this.setState({customer});
	}

	overlayPage() {
		let overlayDivStyle = {};
		let spinnerStyle = {};

		let offsetWidth = document.getElementById('contentDiv').offsetWidth;
		let offsetHeight = document.getElementById('contentDiv').offsetHeight;
		overlayDivStyle.position = 'absolute';
		overlayDivStyle.zIndex = '1';
		overlayDivStyle.background = 'white';
		overlayDivStyle.opacity = '0.5';
		overlayDivStyle.width = offsetWidth;
		overlayDivStyle.height = offsetHeight;

		spinnerStyle.position = 'fixed';
		spinnerStyle.zIndex = '2';
		spinnerStyle.left = '56%';
		spinnerStyle.top = '50%';
		spinnerStyle.fontSize = '50px';

		this.setState({overlayDivStyle, spinnerStyle})
	}

	addNewCustomerReference(partner) {
		let customer = deepCopyObject(this.state.customer);
		let customerReferences = customer.customerReferences ? customer.customerReferences : [];
		let newReference = {partner: partner};
		customerReferences.push(newReference);
		customer.customerReferences = customerReferences;

		this.setState({customer})
	}

	deleteCustomerReference(reference) {
		let customer = deepCopyObject(this.state.customer);
		let customerReferences = customer.customerReferences;

		const deleteAll = () => {
			customerReferences.splice(0, customerReferences.length);
			this.setState({
				customer,
				alert: null
			})
		};

		const deleteSelected = () => {
			let index = null;
			customerReferences.map(cr => {
				if (cr.partner.recordId === reference.partner.recordId) {
					index = customerReferences.indexOf(cr);
				}
			});

			customerReferences.splice(index, 1);

			this.setState({
				customer,
				alert: null
			})
		};

		if (reference.partner.referencePartner === null) {
			this.setState({
				alert: (
					<SweetAlert showCancel warning
								confirmBtnText="Evet"
								cancelBtnText="Hayır"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => deleteAll()}
								onCancel={() => this.setState({alert: null})}
					>
						{"Referans bilgileri sıfırlanacak."}
					</SweetAlert>
				)
			});
		} else {
			this.setState({
				alert: (
					<SweetAlert showCancel warning
								confirmBtnText="Evet"
								cancelBtnText="Hayır"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => deleteSelected()}
								onCancel={() => this.setState({alert: null})}
					>
						{"Emin misiniz ?"}
					</SweetAlert>
				)
			});
		}
	}

	setNewContractList(newList) {
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList: newList,
			}
		});
	}

	getCurrentAliases(newList) {
		let result = [];
		for (let i = 0; i < newList.length; i++) {
			this.combineArray(result, newList[i].customerContractServiceList.map((ccs) => {
				result = this.combineArray(result, ccs.aliasList);
			}));
		}
		return result;
	}

	clearCustomerReferences() {
		let customer = deepCopyObject(this.state.customer);
		let customerReferences = customer.customerReferences;

		customerReferences.splice(0, customerReferences.length);

		this.setState({customer})
	}

	setReferencesToInitialState(initialReferenceList) {
		let customer = deepCopyObject(this.state.customer);
		customer.customerReferences = initialReferenceList;

		this.setState({customer})
	}

	manipulateContractList(id) {
		let customerContractList = deepCopyObject(this.state.customerContractList);
		customerContractList && customerContractList.map(c => {
			c.customerContractServiceList && c.customerContractServiceList.map(cs => {
				if (cs.recordId === id) {
					cs.terminated = true;
				}
			})
		});
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	combineArray(array1, array2) {
		return [].concat(array1, array2);
	}

	render() {

		if (this.state.customer === undefined || this.state.customer === null)
			if (!this.state.isForbidden) {
				return (<div className="row">Yükleniyor...</div>);
			} else {
				return (<div className="row"><h5>Bu sayfaya erişemezsiniz !</h5></div>);
			}

		return (
			<div className="row baseBackground">

				<div>{this.state.alert}</div>

				<div id='overlayDiv' style={this.state.overlayDivStyle}/>
				<i className="fas fa-spinner fa-spin" style={this.state.spinnerStyle}/>

				<div id='contentDiv'>
					<NavBarKS/>

					<div className="satirBasi">
						<div className="">
							<div className="card-header card-header-danger">
								<h4 className="card-title" style={{marginBottom: '20px'}}>Müşteri Genel Bilgileri</h4>
							</div>
							<div className=" col-sm-12 row">
								<div className="col-sm-12 FormRenk  " style={{marginLeft: '15px', paddingTop: '30px'}}>
									<CustomerGeneralInfo ref={instance => {
										this.generalInfoChild = instance
									}}
														 impersonateUserRoleId={this.props.impersonateUserRoleId}
														 customer={this.state.customer}
														 onChangeCustomer={this.onChangeCustomer}
														 onCustomerTypeChange={this.onCustomerTypeChange}
														 onDistributorChange={this.onDistributorChange}
														 onCustomerStatusChange={this.onCustomerStatusChange}
														 onInvoiceDirectionChange={this.onInvoiceDirectionChange}
														 onInvoiceWorkTypeChange={this.onInvoiceWorkTypeChange}
														 mode={this.state.mode}
														 naceCodes={this.state.naceCodes}
														 onChangeNaceCodes={this.onChangeNaceCodes}
														 naceCodeList={this.state.naceCodeList}
														 name={this.props.name}
														 isEntegrator={this.props.isEntegrator}
														 isDistributor={this.props.isDistributor}
														 currentUser={this.props.currentUser}
														 fieldsDisabled={this.state.fieldsDisabled}
														 switch/>


									<div className="">
										<CustomerCommercialInfo ref={instance => {
											this.commercialInfoChild = instance
										}}
																customer={this.state.customer}
																onChangeCustomer={this.onChangeCustomer}
																onTaxOfficeChange={this.onTaxOfficeChange}
																mode={this.state.mode}
																taxOffices={this.state.taxOffices}
																cities={this.state.cities}
																onChangeCustomerCity={this.onChangeCustomerCity}
																commercialSoftwares={this.state.commercialSoftwares}
																onCommercialSoftwareChange={this.onCommercialSoftwareChange}
																partners={this.state.partners}
																addNewCustomerReference={this.addNewCustomerReference}
																deleteCustomerReference={this.deleteCustomerReference}
																clearCustomerReferences={this.clearCustomerReferences}
																setReferencesToInitialState={this.setReferencesToInitialState}
																fieldsDisabled={this.state.fieldsDisabled}
																switch/>
									</div>
								</div>
							</div>
						</div>


						<div className="card-nav-tabs">
							<div className="">

								<div className="card-header card-header-danger">
									<h4 className="card-title">{this.defineTabName()}</h4>
								</div>

								<div className="col-sm-12">
									<Nav pills className="nav-pills-primary ">
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '1'})}
												onClick={() => {
													this.toggle('1');
												}}
											>
												Sözleşme Bilgileri
											</NavLink>
										</NavItem>

										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '2'})}
												onClick={() => {
													this.toggle('2');
												}}
											>
												Şube Bilgileri
											</NavLink>
										</NavItem>

										{this.state.mode === 'create' &&
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '3'})}
												onClick={() => {
													this.toggle('3');
												}}
											>
												Banka Bilgileri
											</NavLink>
										</NavItem>}

										{this.state.mode === 'edit' &&
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '7'})}
												onClick={() => {
													this.toggle('7');
												}}
											>
												TÜRMOB Token Bilgisi
											</NavLink>
										</NavItem>}

										{this.state.mode === 'edit' && EntegratorIdentifiers.VEGA === EntegratorConf.identifier && !!this.state.customer.earchiveSmsSend &&
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '6'})}
												onClick={() => {
													this.toggle('6');
												}}
											>
												SMS Bilgisi
											</NavLink>
										</NavItem>}
									</Nav>
								</div>

								<hr style={{marginBottom: '20px'}}></hr>


								<div className="card-body">
									<TabContent activeTab={this.state.activeTab}>
										<TabPane tabId="1">
											<div className="">
												<div className="">
													<CustomerContractInfo
														key={this.state.customer ? this.state.customer.recordId : 'customer-loading'}
														ref={instance => {
														this.contractInfoChild = instance
													}}
																		  impersonateUserRoleId={this.props.impersonateUserRoleId}
																		  onChangeInvalidatedContractPrice={this.onChangeInvalidatedContractPrice}
																		  onChangeInvalidatedContractExplanation={this.onChangeInvalidatedContractExplanation}
																		  customer={this.state.customer}
																		  services={this.state.services}
																		  name={this.props.name}
																		  addServices={(list) => this.getServicesFromChild(list)}
																		  updateCustomer={this.updateCustomer}
																		  setContractToCustomer={this.setContractToCustomer}
																		  customerContractList={this.state.customerContractList}
																		  addContractToCustomer={this.addContractToCustomer}
																		  passRecentAliasList={this.passRecentAliasList}
																		  currencyCodes={this.state.currencyCodes}
																		  history={this.props.history}
																		  removeAlias={this.removeAlias}
																		  isEntegrator={this.props.isEntegrator}
																		  isAdminUser={this.props.isAdminUser}
																		  isDistributor={this.props.isDistributor}
																		  manipulateContractList={this.manipulateContractList}
																		  currentUser={this.props.currentUser}
																		  setNewContractList={this.setNewContractList}
																		  fieldsDisabled={this.state.fieldsDisabled}
																		  distributorContractList={this.state.distributorContractList}
																		  reFetchCustomer={this.reFetchCustomer}
																		  switch/>
												</div>
											</ div>
										</TabPane>

										<TabPane tabId="2">
											<Row>
												<Col sm="12">
													<CustomerBranchInfo ref={instance => {
														this.branchInfoChild = instance
													}}
																		branchList={this.state.customerBranchList}
																		fillAddressForm={this.fillAddressForm}
																		customerBranchAddress={this.state.customerBranchAddress}
																		cities={this.state.cities}
																		getSubdivisions={this.getSubdivisionsByCityForBranch}
																		onChangeCustomerBranchAddress={this.onChangeCustomerBranchAddress}
																		onCityChange={this.onCityChange}
																		onAliasChange={this.onAliasChange}
																		onCitySubdivisionChange={this.onCitySubdivisionChange}
																		addBranchToCustomer={this.addBranchToCustomer}
																		customerContractList={this.state.customerContractList}
																		aliasList={this.state.recentAliasList}
																		clearCustomerBranchAddress={this.clearCustomerBranchAddress}
																		mode={this.state.mode}
																		reload={this.props.reload}
																		fieldsDisabled={this.state.fieldsDisabled}
																		bankList={this.state.bankList}
													/>
												</Col>
											</Row>
										</TabPane>

										<TabPane tabId="3">
											<Row>
												<Col sm="12">
													<CustomerBankInfo ref={instance => {
														this.bankInfoChild = instance
													}}
																	  customer={this.state.customer}
																	  currentTitle={this.state.currentTitle}
																	  onChangeCustomerBank={this.onChangeCustomerBank}
																	  customerBank={this.state.customerBank}
																	  addBankToCustomer={this.addBankToCustomer}
																	  customerBankList={this.state.customerBankList}
																	  fillBankForm={this.fillBankForm}
																	  clearForm={this.clearExternalCustomerBank}
																	  deleteBank={this.deleteBankFromExternalCustomer}
																	  clearCustomerBank={this.clearCustomerBank}
																	  fieldsDisabled={this.state.fieldsDisabled}
																	  bankList={this.state.bankList}
													/>
												</Col>
											</Row>
										</TabPane>

										{this.state.mode === 'edit' &&
										<TabPane tabId="4">
											<Row>
												<Col sm="12">
													<CustomerUserInfo userList={this.state.userList}/>
												</Col>
											</Row>
										</TabPane>}

										{this.state.mode === 'edit' &&
										<TabPane tabId="5">
											<MailProperty customer={this.state.customer}/>
										</TabPane>
										}

										{this.state.mode === 'edit' && EntegratorIdentifiers.VEGA === EntegratorConf.identifier &&
										<TabPane tabId="6">
											<SmsProperty
											customer={this.state.customer}/>
										</TabPane>
										}

										{this.state.mode === 'edit' &&
											<TabPane tabId="7">
												<TurmobModal customer={this.state.customer} userList={this.state.userList}/>
											</TabPane>
										}
									</TabContent>
								</div>
							</div>

							{this.state.mode === 'create' &&
							<div>
								<div className="col-sm-12">
									<nav className="col-sm-12">
										<button type="button" data-toggle="tooltip" data-placement="bottom"
												style={{
													background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
													float: 'right'
												}}
												rel="tooltip" className="TekBtn kaydet btn-icon"
												onClick={() => {
													this.checkBeforeSubmit()
												}}>Müşterİyİ Kaydet
										</button>
									</nav>
								</div>
							</div>}

							{this.state.mode === 'edit' &&
							<div key={this.state.key} className="col-sm-12 row" style={{margin: '20px 0 0 0'}}>
								<div className='col-sm-8'/>
								<div className='col-sm-2'>
									<button type="button" data-toggle="tooltip" data-placement="bottom"
											style={{
												background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
												float: 'right'
											}}
											rel="tooltip" className="TekBtn kaydet btn-icon"
											title='Kaydet ve sayfada kal'
											disabled={this.state.fieldsDisabled}
											onClick={() => {
												this.checkBeforeSubmit(this.state.customer.recordId)
											}}>Kaydet
									</button>
								</div>
								<div className='col-sm-2'>
									<button type="button" data-toggle="tooltip" data-placement="bottom"
											style={{
												background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
												float: 'right'
											}}
											rel="tooltip" className="TekBtn kaydet btn-icon"
											title='Kaydet ve müşteri listesine dön'
											disabled={this.state.fieldsDisabled}
											onClick={() => {
												this.checkBeforeSubmit(null)
											}}>Kaydet & Kapat
									</button>
								</div>
							</div>
							}
						</div>

						<Modal isOpen={this.state.branchConfirmModal}>
							<ModalHeader toggle={this.toggle}>Emin misiniz ?</ModalHeader>
							<ModalBody>
								En az bir şube kaydı olmadan müşteri kaydedilemez.
							</ModalBody>
							<ModalFooter>
								{/*<Button color="primary"*/}
								{/*onClick={() => this.setState({branchConfirmModal: false}, this.handleSubmit())}>Kaydet</Button>*/}
								<div className="col-sm-4">
									<Button color="primary" className="TekBtn ekle"
											onClick={() => this.setState({branchConfirmModal: false}, this.switchBranchDetailModal())}>Şube
										Ekle</Button>
								</div>
								<div className="col-sm-4"></div>
								<div className="col-sm-4">
									<Button color="secondary" onClick={() => this.setState({
										branchConfirmModal: false
									})}>İptal</Button>
								</div>
							</ModalFooter>
						</Modal>
					</div>
				</div>
			</div>
		)
	}
}

export default CreateEditCustomer;

